import {
  SET_SPINNER_FLAG
} from "../../constants/_spinner_constants";

export const SET_SPINNER_FLAG_ACTION = (flag) => ({
  type: SET_SPINNER_FLAG,
  payload: flag
});
